import parsePhoneNumber from 'libphonenumber-js'

// Validate phone number using libphonenumber-js
export const validatePhoneNumberFormat = (phoneNumber) => {
    try {
        if (!phoneNumber || phoneNumber.trim() === '') {
            return { isValid: false, error: 'Phone number is required' };
        }
        const formattedNumber = handelNumber(phoneNumber);
        const parsedNumber = parsePhoneNumber(formattedNumber);
        const isValid = parsedNumber.isValid();
        return {
            isValid,
            error: isValid ? '' : 'Invalid phone number format. Please check and correct.',
            parsedNumber: isValid ? parsedNumber : null
        };
    } catch (error) {
        return { 
            isValid: false, 
            error: 'Invalid phone number format. Please check and correct.',
            parsedNumber: null
        };
    }
};

export const getCountryCode = (phoneNumber) => {
    try {
        const parsedNumber = parsePhoneNumber(phoneNumber);
        return parsedNumber.countryCallingCode;
    } catch (error) {
        return "Invalid country code";
    }
};
export const getPhoneNumber = (phoneNumber,countryCode) => {
  return   phoneNumber.replaceAll("+"+countryCode,"")
};


export const handelNumber = (phoneNumber) => {
    var  number = phoneNumber;

    if (!phoneNumber.startsWith("+")) {
        number = "+" + phoneNumber;
    }else{
        number = phoneNumber;
    }
     if (number.startsWith("+00")){
        console.log("first",number)
        number =  "+" + number.slice(3);
    }else{
        number = number;
    }

    return number

};
